import Vue from 'vue'
import Vuetify from 'vuetify'
import store from '~/store'
import router from '~/router'
import { i18n } from '~/plugins'
import App from '~/components/App'
import '~/components'

import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

Vue.config.productionTip = false

import VueStripeCheckout from 'vue-stripe-checkout';
Vue.use(VueStripeCheckout, process.env.STRIPE_KEY);
window.Vue = Vue;
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./src/app.js